<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>

<div style="margin-top:20px;margin-left:25px;">
  <span style="font-size:18px;font-weight: bold;" >Add This Parker To Flash</span>
</div>
<div style="height:220px;overflow-y: hidden;overflow-x: hidden;">    <div class="row" style="margin-top:10px;margin-left:25px;">
        <div class="col-11" style="padding:10px;">
            <div style="margin-left:5px;">
                <mat-form-field style="width:600px;">
                <mat-label>Select Flash Profile*</mat-label>
                <mat-select [ngModel]="selectedProfileId" (ngModelChange)="onProfileSelectionChange($event)">
                    @if(profileList.length === 0){
                        <mat-option value="" disabled="true"><strong>Loading Flash Profiles...</strong></mat-option>
                    }
                    @else{
                      <mat-option value=""><strong>Select Flash Profile</strong></mat-option>
                      @for (profile of profileList; track profile.uniqueID) {
                        <mat-option [value]="profile.uniqueID">{{profile.name}}</mat-option>
                      }
                    }
                </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="row" style="margin-left:25px;">
        <div class="col-11" style="padding:10px;">
            <div style="margin-left:5px;">
                <mat-form-field style="width:600px;">
                <mat-label>Select Pool*</mat-label>
                <mat-select [ngModel]="selectedPoolName" (ngModelChange)="onPoolSelectionChange($event)">
                    @if(poolList.length === 0){
                        <mat-option value="" disabled="true"><strong>No Pools configured for this Lot</strong></mat-option>
                    }
                    @else{
                      <mat-option value=""><strong>Select Pool</strong></mat-option>
                      @for (pool of poolList; track pool.poolId) {
                        <mat-option [value]="pool.poolName">{{pool.poolName}}</mat-option>
                      }
                    }
                </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="row" style="margin-left:25px;">
        <div class="col-11" style="padding:10px;">
            <div style="margin-left:5px;">
                Card Number: <span style="font-weight:bold;">{{data.cardNumber || '--'}}</span>
            </div>
        </div>
    </div>
</div>
<div>
<img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:25px;position:relative;">

<div mat-dialog-actions align="end" style="position:relative;top: -20px;">
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  @if(submitButtonDisabled) {
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial style="background-color:lightgray !important;color:darkgray !important" disabled="true">Submit</button>
  }
  @else{
    <button mat-button [mat-dialog-close]="newFlashAddNewAccountRequest" cdkFocusInitial style="background-color:#003087 !important;color:white !important">Submit</button>
  }
</div>
</div>
